import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Globals } from '../models/globals.model';
import { RulesModel } from '../models/rules/rules.model';

@Injectable({
  providedIn: 'root'
})
export class DataCleansingService {

  apiUri: string;
  graphUri: string;

  getAllRulesApi = "api/datacleansing/getdatacleansingconfigs";
  getDataSourceParametersApi = "api/datacleansing/gettags/";
  getDataSourcesApi = "api/datacleansing/getdatasources";
  getCleansingRulesListApi = "api/datacleansing/getrulenames";
  getCleansingRulesEditApi = "api/datacleansing/getdatacleansingrules";
  saveCleansingRules = "api/datacleansing/saverules/";
  deleteCleansingRuleApi = "api/datacleansing/deleterules/";
  tokenApi = "api/datacleansing/getToken";

  constructor(private readonly globals: Globals, private readonly http: HttpClient) {
    this.apiUri = this.globals.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  getAllRules() {
    return this.http.get(this.apiUri + this.getAllRulesApi);
  }
  getToken() {
    return this.http.get(this.apiUri + this.tokenApi);
  }

  getDataSources() {
    return this.http.get(this.apiUri + this.getDataSourcesApi);
  }

  getDataSourceParameters(dataSourceId: number) {
    return this.http.get(this.apiUri + this.getDataSourceParametersApi + dataSourceId);
  }

  listAllCleansingRules() {
    return this.http.get(this.apiUri + this.getCleansingRulesListApi);
  }

  listCleansingRulesForSelectedId(dataSourceId: string, tagName: string) {
    let params = new HttpParams().set('dataSource', dataSourceId)
      .set('tagName', tagName);
    return this.http.get(this.apiUri + this.getCleansingRulesEditApi, { params });
  }

  saveCleansingRule(cleansingRules: RulesModel) {
    return this.http.post<any>(this.apiUri + this.saveCleansingRules, cleansingRules);
  }

  deleteCleansingRule(dataCleansingConfigId) {
    return this.http.post<any>(this.apiUri + this.deleteCleansingRuleApi + dataCleansingConfigId, null);
  }
  
}
